var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var ComponentAttribute = require('./componentAttribute.js');

var ChipArrayTwoSideFlatConcaveData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    //component family if any
    this.componentFamily = this.value("componentFamily", true);

    //lead shape
    this.leadShapeType = this.value("leadShapeType", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
    this.nonTransformedSegmentedGeometry.addTrigger(this.leadShapeType);
};

lib_core.inherit(ChipArrayTwoSideFlatConcaveData, DualRowPackageData);
lib_core.JsonParser.registerClass(ChipArrayTwoSideFlatConcaveData, "ChipArrayTwoSideFlatConcaveData");

module.exports = ChipArrayTwoSideFlatConcaveData;
